function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.97 5.5v4a3.5 3.5 0 01-3.002 3.465c-.273.039-.498-.189-.498-.465v-.25c0-3.72-3.02-6.75-6.75-6.75h-.25c-.276 0-.504-.225-.465-.498A3.505 3.505 0 0114.47 2h4c1.94 0 3.5 1.57 3.5 3.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.72 7H6.97c-2.76 0-5 2.24-5 5v5c0 2.76 2.24 5 5 5h5c2.76 0 5-2.24 5-5v-4.75c0-2.9-2.35-5.25-5.25-5.25z"
})));